"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGsacIssuer = exports.GetBotEmailFromAsapIssuer = exports.AsapIssuerBotEmails = exports.AsapIssuerToBotEmailProd = exports.AsapIssuerToBotEmailStg = exports.AsapIssuer = void 0;
// import { isProduction } from './helpers/app-environment';
const security_1 = require("./security");
var AsapIssuer;
(function (AsapIssuer) {
    AsapIssuer["IA_CLOUD_SITE_PARTNER_SERVICE"] = "micros/suzie-q";
    AsapIssuer["IA_CLOUD_SITE_REACTIVATION_SERVICE"] = "mulesoft/atl-ia-cassi-sys-api";
    AsapIssuer["POLLINATOR_STG"] = "pollinator-check/d4377459-282f-42aa-b5c4-3c1baca6d5a3";
    AsapIssuer["CASSI_TEST_BOT"] = "cassi-test-bot";
    AsapIssuer["IPA_QE_BOT"] = "ipa-qe-bot";
    AsapIssuer["SMART_ADVOCATE_BOT"] = "smart-advocate-bot";
    AsapIssuer["RPA_MANAGED_SERVICES"] = "rpa-managed-services";
    AsapIssuer["CASSI"] = "micros/customer-billing-administration-connect";
    AsapIssuer["CSS_XP_ANS_SVC"] = "micros/css-xp-ans-svc";
    AsapIssuer["CSS_XP_PC_SERVER"] = "micros/css-xp-pcserver";
    AsapIssuer["SUZIE_Q"] = "micros/suzie-q";
    AsapIssuer["CLOUD_PROVISIONER"] = "micros/cloud-provisioner";
    AsapIssuer["THE_DEALER"] = "micros/the-dealer";
    AsapIssuer["BREACH_NOTIFICATION_SERVICE"] = "micros/breach-notifications";
    AsapIssuer["APPROVAL_DESK"] = "micros/approval-desk";
    AsapIssuer["AURA_EXECUTOR_SVC"] = "micros/aura-executor-svc";
})(AsapIssuer = exports.AsapIssuer || (exports.AsapIssuer = {}));
// ASAP principals that have an associated bot account
// and the emails addresses will be how the permissions are done.
exports.AsapIssuerToBotEmailStg = new Map([
    [AsapIssuer.RPA_MANAGED_SERVICES, 'rpa-finstg-bot@atlassian.com'],
    [AsapIssuer.CASSI_TEST_BOT, 'cassi-test-bot@atlassian.com'],
    [AsapIssuer.IPA_QE_BOT, 'ipa-qe-bot@atlassian.com'],
    [AsapIssuer.SMART_ADVOCATE_BOT, 'smart-advocate-bot@atlassian.com'],
]);
exports.AsapIssuerToBotEmailProd = new Map([
    [AsapIssuer.RPA_MANAGED_SERVICES, 'rpa-gtm-bot@atlassian.com'],
    [AsapIssuer.CASSI_TEST_BOT, 'cassi-test-bot@atlassian.com'],
    [AsapIssuer.IPA_QE_BOT, 'ipa-qe-bot@atlassian.com'],
    [AsapIssuer.SMART_ADVOCATE_BOT, 'smart-advocate-bot@atlassian.com'],
]);
exports.AsapIssuerBotEmails = Array.from(exports.AsapIssuerToBotEmailStg.values()).concat(Array.from(exports.AsapIssuerToBotEmailProd.values()));
const GetBotEmailFromAsapIssuer = (principal) => {
    // if (isProduction()) {
    //     return AsapIssuerToBotEmailProd.get(principal);
    // } else {
    return exports.AsapIssuerToBotEmailStg.get(principal);
    //}
};
exports.GetBotEmailFromAsapIssuer = GetBotEmailFromAsapIssuer;
const GetGsacIssuer = (request) => {
    const principal = request.header(security_1.SlauthHeader.PRINCIPAL) ?? '';
    if (!!principal && principal.includes('gsac')) {
        return request.header(security_1.SlauthHeader.SUBJECT);
    }
    else {
        return undefined;
    }
};
exports.GetGsacIssuer = GetGsacIssuer;
